define("shared/components/shared/carousel", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@glidejs/glide"], function (_exports, _component, _templateFactory, _component2, _object, _glide) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@glidejs/glide",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cPM--carouselWrapper">
    <div
      {{did-insert this.glide}}
      {{did-update this.glide @postMediaItems @activeIndex}}
      class="cPM--slideWrapper glide"
    >
      {{!-- Note: Fix unless statements so that black background are removed when at first and last slide --}}
      <div class="glide__arrows" data-glide-el="controls">
  
        {{#unless this.onFirstSlide}}
          <span class="cPM--slide__prev glide__arrow glide__arrow--left qa--carousel_slide_prev_icon" data-glide-dir="<">
            {{svg-jar "nav-left" class="o--icon--sm o--icon--white"}}
          </span>
        {{/unless}}
  
      </div>
  
      <div class="glide__track" data-glide-el="track">
        <div class="glide__slides cPM--slides">
          {{#each @postMediaItems as |postMediaItem index|}}
            <div class="item cPM--slide__item">
              <Post::Media::SingleMedia
                @mediaItem={{await (unwrap-proxy postMediaItem.mediaItem)}}
                @post={{@post}}
                @postMediaItem={{postMediaItem}}
                @socialProfile={{@socialProfile}}
                @isCarouselPost={{@isCarouselPost}}
                @onMediaClick={{@onMediaClick}}
                @validMediaCount={{@validMediaCount}}
                @index={{index}}
              />
            </div>
          {{/each}}
        </div>
      </div>
  
      <div class="glide__arrows" data-glide-el="controls">
  
        {{#unless this.onLastSlide}}
          <span class="cPM--slide__next glide__arrow glide__arrow--right qa--carousel_slide_next_icon" data-glide-dir=">">
            {{svg-jar "nav-right" class="o--icon--sm o--icon--white"}}
          </span>
        {{/unless}}
  
      </div>
  
      <ol class="carousel-indicators" data-glide-el="controls[nav]">
        {{#each @postMediaItems as |postMediaItem index|}}
          <li class="glide__bullet"  data-glide-dir="={{index}}"></li>
        {{/each}}
  
      </ol>
  
    </div>
  </div>
  
  */
  {
    "id": "aTezVkRD",
    "block": "[[[10,0],[14,0,\"cPM--carouselWrapper\"],[12],[1,\"\\n  \"],[11,0],[24,0,\"cPM--slideWrapper glide\"],[4,[38,0],[[30,0,[\"glide\"]]],null],[4,[38,1],[[30,0,[\"glide\"]],[30,1],[30,2]],null],[12],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"glide__arrows\"],[14,\"data-glide-el\",\"controls\"],[12],[1,\"\\n\\n\"],[41,[51,[30,0,[\"onFirstSlide\"]]],[[[1,\"        \"],[10,1],[14,0,\"cPM--slide__prev glide__arrow glide__arrow--left qa--carousel_slide_prev_icon\"],[14,\"data-glide-dir\",\"<\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"nav-left\"],[[\"class\"],[\"o--icon--sm o--icon--white\"]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"glide__track\"],[14,\"data-glide-el\",\"track\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"glide__slides cPM--slides\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,1]],null]],null],null,[[[1,\"          \"],[10,0],[14,0,\"item cPM--slide__item\"],[12],[1,\"\\n            \"],[8,[39,6],null,[[\"@mediaItem\",\"@post\",\"@postMediaItem\",\"@socialProfile\",\"@isCarouselPost\",\"@onMediaClick\",\"@validMediaCount\",\"@index\"],[[28,[37,7],[[28,[37,8],[[30,3,[\"mediaItem\"]]],null]],null],[30,5],[30,3],[30,6],[30,7],[30,8],[30,9],[30,4]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[3,4]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"glide__arrows\"],[14,\"data-glide-el\",\"controls\"],[12],[1,\"\\n\\n\"],[41,[51,[30,0,[\"onLastSlide\"]]],[[[1,\"        \"],[10,1],[14,0,\"cPM--slide__next glide__arrow glide__arrow--right qa--carousel_slide_next_icon\"],[14,\"data-glide-dir\",\">\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"nav-right\"],[[\"class\"],[\"o--icon--sm o--icon--white\"]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"ol\"],[14,0,\"carousel-indicators\"],[14,\"data-glide-el\",\"controls[nav]\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,1]],null]],null],null,[[[1,\"        \"],[10,\"li\"],[14,0,\"glide__bullet\"],[15,\"data-glide-dir\",[29,[\"=\",[30,11]]]],[12],[13],[1,\"\\n\"]],[10,11]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@postMediaItems\",\"@activeIndex\",\"postMediaItem\",\"index\",\"@post\",\"@socialProfile\",\"@isCarouselPost\",\"@onMediaClick\",\"@validMediaCount\",\"postMediaItem\",\"index\"],false,[\"did-insert\",\"did-update\",\"unless\",\"svg-jar\",\"each\",\"-track-array\",\"post/media/single-media\",\"await\",\"unwrap-proxy\"]]",
    "moduleName": "shared/components/shared/carousel.hbs",
    "isStrictMode": false
  });

  let SharedCarouselComponent = (_class = class SharedCarouselComponent extends _component2.default {
    get onFirstSlide() {
      return this.args.activeIndex === 0;
    }

    get onLastSlide() {
      return this.args.activeIndex === this.args.postMediaItems.length - 1;
    }

    glide(element) {
      this.carousel = new _glide.default(element, {
        animationDuration: 100,
        rewind: false,
        startAt: this.args.activeIndex,
        classes: {
          activeNav: 'active'
        }
      }).on('run.after', () => {
        // runs after the current slide is changed
        if (this.args.activeIndex != this.carousel.index) {
          this.args.setActiveIndex(this.carousel.index);
        }
      }).mount();
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "glide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "glide"), _class.prototype)), _class);
  _exports.default = SharedCarouselComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SharedCarouselComponent);
});